{
  "familyId": "GET-KOMMA-GETALLENLIJN",
  "questions": [
    {
      "id": "GET-KOMMA-GETALLENLIJN-001",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een leraar tekent een getallenlijn van 0 tot 1, verdeeld in 10 gelijke stukken. Een leerling zegt: 'Het zevende streepje is 0,07.' Wat klopt er niet?",
      "options": [
        "Elk stukje is 0,1 — het zevende streepje is 0,7",
        "Elk stukje is 0,07 — het antwoord klopt",
        "Elk stukje is 1 — het zevende streepje is 7",
        "Je kunt het niet weten zonder meer informatie"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.1,
            "markers": [
              {"value": 0, "label": "0"},
              {"value": 0.5, "label": "0,5"},
              {"value": 1, "label": "1"}
            ],
            "highlight": [0.7],
            "label": "Getallenlijn van 0 tot 1, verdeeld in 10 stukken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1,
            "marked": [0.7],
            "highlight": [0.7],
            "step": 0.1,
            "arrows": [{"from": 0, "to": 0.7, "label": "7 stappen van 0,1"}],
            "label": "10 stukken van 0 tot 1 → elk stukje = 0,1. Zevende streepje = 0,7"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.komma-tienden-vs-honderdsten", "label": "Verwart tienden met honderdsten", "optionIndex": 1 },
          { "id": "get.komma-schaal-genegeerd", "label": "Negeert het bereik van de getallenlijn", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling verwart tienden met honderdsten. De lijn van 0 tot 1 is verdeeld in 10 stukken. Elk stukje = 1 ÷ 10 = 0,1 (één tiende). Het zevende streepje = 7 × 0,1 = 0,7 (niet 0,07). 0,07 zou kloppen als er 100 stukken waren.",
        "solutionSteps": [
          "Bereken de stapgrootte: bereik ÷ aantal stukken = 1 ÷ 10 = 0,1",
          "Herken de fout: de leerling dacht dat elk stukje 0,01 is (honderdsten in plaats van tienden)",
          "Bereken het juiste antwoord: 7 × 0,1 = 0,7",
          "Controleer: 0,7 ligt tussen 0 en 1 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Elk stukje = 0,1 (tienden), niet 0,01 (honderdsten). Het zevende streepje = 7 × 0,1 = 0,7.",
          "1": "Je dacht waarschijnlijk dat de leerling gelijk heeft. Maar elk stukje is 0,1 (niet 0,01). 0,07 zou kloppen als de lijn in 100 stukken was verdeeld. Bij 10 stukken is het antwoord 0,7.",
          "2": "Je dacht waarschijnlijk dat de lijn van 0 tot 10 loopt. Maar de lijn loopt van 0 tot 1. Elk stukje = 0,1, niet 1. Het zevende streepje is 0,7, niet 7.",
          "3": "Je dacht waarschijnlijk dat er meer informatie nodig is. Maar je weet genoeg: bereik = 1, aantal stukken = 10, dus stap = 0,1. Zevende streepje = 0,7."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-002",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 3 tot 4, verdeeld in 10 stukken, welk getal hoort bij het vierde streepje?",
      "options": ["3,4", "3,04", "4,4", "0,4"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 3,
            "end": 4,
            "step": 0.1,
            "markers": [
              {"value": 3, "label": "3"},
              {"value": 3.5, "label": "3,5"},
              {"value": 4, "label": "4"}
            ],
            "label": "Getallenlijn van 3 tot 4, verdeeld in 10 stukken — tel zelf naar het vierde streepje"
          }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 3,
            "end": 4,
            "marked": [3.4],
            "highlight": [3.4],
            "step": 0.1,
            "arrows": [{"from": 3, "to": 3.4, "label": "4 stappen van 0,1 vanaf 3"}],
            "label": "Start bij 3, elk stukje = 0,1. Vierde streepje = 3,4"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_niet_nul",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De lijn loopt van 3 tot 4, verdeeld in 10 stukken. Stap = (4 − 3) ÷ 10 = 0,1. Begin bij 3. Het vierde streepje = 3 + 4 × 0,1 = 3 + 0,4 = 3,4. Controleer: 3,4 ligt tussen 3 en 4 ✓.",
        "solutionSteps": [
          "Bereken de stapgrootte: (4 − 3) ÷ 10 = 0,1",
          "Begin bij het startpunt: 3",
          "Tel 4 stappen op: 3 + (4 × 0,1) = 3 + 0,4 = 3,4",
          "Controleer: 3 < 3,4 < 4 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Start bij 3, elk streepje = 0,1. Vierde streepje = 3 + 0,4 = 3,4.",
          "1": "Je dacht waarschijnlijk dat elk stukje 0,01 is. Maar bij 10 stukken van 3 tot 4 is elk stukje 0,1, niet 0,01. 3,04 zou kloppen als er 100 stukken waren. Onthoud: stap = bereik ÷ aantal stukken = 1 ÷ 10 = 0,1.",
          "2": "Je dacht waarschijnlijk dat de lijn van 4 tot 5 loopt. Maar de lijn loopt van 3 tot 4. Het vierde streepje is 3,4, niet 4,4. Onthoud: kijk altijd naar het begin van de getallenlijn.",
          "3": "Je dacht waarschijnlijk dat de lijn bij 0 begint. Maar de lijn begint bij 3. Het vierde streepje = 3 + 0,4 = 3,4, niet 0,4. Onthoud: tel altijd vanaf het startpunt van de lijn."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-003",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een leerling zegt: '7,85 ligt tussen 8 en 9 op de getallenlijn.' Klopt dat?",
      "options": [
        "Nee, 7,85 ligt tussen 7 en 8",
        "Ja, dat klopt",
        "Nee, 7,85 ligt tussen 7,8 en 7,9",
        "Nee, 7,85 ligt tussen 78 en 79"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 7,
            "end": 9,
            "step": 0.5,
            "markers": [
              {"value": 7, "label": "7"},
              {"value": 7.85, "label": "?"},
              {"value": 8, "label": "8"},
              {"value": 9, "label": "9"}
            ],
            "highlight": [7.85],
            "label": "Waar ligt 7,85 op de getallenlijn?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Positie op de getallenlijn bepalen",
            "content": "Kijk naar het getal vóór de komma. Dat vertelt je tussen welke twee hele getallen het getal ligt. 7,85 → het hele getal is 7 → het ligt tussen 7 en 8.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_positie",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De leerling heeft het fout. Kijk naar het getal vóór de komma in 7,85: dat is 7. 7,85 is groter dan 7 maar kleiner dan 8. Dus 7,85 ligt tussen 7 en 8, niet tussen 8 en 9. De leerling heeft waarschijnlijk naar de 85 achter de komma gekeken en gedacht dat het getal groter is dan 8.",
        "solutionSteps": [
          "Kijk naar het getal vóór de komma: 7",
          "7,85 is groter dan 7 maar kleiner dan 8",
          "Dus 7,85 ligt tussen 7 en 8 (niet tussen 8 en 9)",
          "De leerling verwart het deel achter de komma (85) met het hele getal"
        ],
        "distractorExplanations": {
          "0": "Goed! 7,85 ligt tussen 7 en 8. Het hele getal vóór de komma is 7, niet 8.",
          "1": "Je dacht waarschijnlijk dat de leerling gelijk heeft. Maar 7,85 is kleiner dan 8 — het ligt nog vóór 8 op de getallenlijn. Kijk naar het getal vóór de komma: 7 → tussen 7 en 8.",
          "2": "Tussen 7,8 en 7,9 is ook correct, maar de vraag gaat over hele getallen. De leerling zei 'tussen 8 en 9', en dat is fout — het moet 'tussen 7 en 8' zijn.",
          "3": "Je dacht waarschijnlijk dat de komma er niet toe doet en dat 7,85 hetzelfde is als 785. Maar 7,85 is een kommagetal tussen 7 en 8, niet een heel getal tussen 78 en 79."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-004",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 0,1 (verdeeld in 10 stukken) staat een pijl op het derde streepje. Welk getal is dat?",
      "options": ["0,03", "0,3", "0,003", "3"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0,
            "end": 0.1,
            "step": 0.01,
            "markers": [
              {"value": 0, "label": "0"},
              {"value": 0.05, "label": "0,05"},
              {"value": 0.1, "label": "0,1"}
            ],
            "label": "Getallenlijn van 0 tot 0,1, verdeeld in 10 stukken — tel zelf naar het derde streepje"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stapgrootte berekenen",
            "content": "Stap = bereik ÷ aantal stukken. Bereik van 0 tot 0,1 = 0,1. Aantal stukken = 10. Stap = 0,1 ÷ 10 = 0,01. Derde streepje = 3 × 0,01 = 0,03.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_honderdsten",
      "variantIndex": 4,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De lijn loopt van 0 tot 0,1 in 10 stukken. Stap = 0,1 ÷ 10 = 0,01 (honderdsten). Derde streepje = 3 × 0,01 = 0,03. Controleer: 0,03 ligt tussen 0 en 0,1 ✓.",
        "solutionSteps": [
          "Bepaal het bereik: van 0 tot 0,1 = 0,1",
          "Bereken de stapgrootte: 0,1 ÷ 10 = 0,01 (honderdsten)",
          "Tel 3 stappen: 3 × 0,01 = 0,03",
          "Controleer: 0 < 0,03 < 0,1 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Van 0 tot 0,1 in 10 stukken → stap = 0,01. Derde streepje = 0,03.",
          "1": "Je dacht waarschijnlijk dat de lijn van 0 tot 1 loopt. Maar de lijn loopt van 0 tot 0,1 — dat is tien keer kleiner. Elk stukje = 0,01, niet 0,1. Onthoud: kijk altijd naar het einde van de getallenlijn.",
          "2": "Je dacht waarschijnlijk dat de lijn van 0 tot 0,01 loopt. Maar de lijn loopt van 0 tot 0,1. Elk stukje = 0,01, niet 0,001. Onthoud: stap = bereik ÷ aantal stukken = 0,1 ÷ 10 = 0,01.",
          "3": "Je dacht waarschijnlijk dat de lijn van 0 tot 10 loopt. Maar de lijn loopt van 0 tot 0,1. Het derde streepje = 0,03, niet 3. Onthoud: kijk altijd naar het begin en einde van de getallenlijn."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-005",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Welk kommagetal ligt precies halverwege 2,4 en 2,6?",
      "options": ["2,5", "2,45", "2,55", "2,10"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 2.4,
            "end": 2.6,
            "step": 0.05,
            "markers": [
              {"value": 2.4, "label": "2,4"},
              {"value": 2.5, "label": "?"},
              {"value": 2.6, "label": "2,6"}
            ],
            "label": "Welk getal hoort bij het ? — halverwege 2,4 en 2,6"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Halverwege op de getallenlijn",
            "content": "Het getal halverwege twee getallen bereken je door ze op te tellen en door 2 te delen. Of: neem het verschil, deel door 2, en tel op bij het kleinste getal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_getallenlijn_halverwege",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Halverwege 2,4 en 2,6: tel op en deel door 2. 2,4 + 2,6 = 5,0. 5,0 ÷ 2 = 2,5. Of: het verschil is 0,2, de helft is 0,1. 2,4 + 0,1 = 2,5. Controleer: 2,5 − 2,4 = 0,1 en 2,6 − 2,5 = 0,1 ✓.",
        "solutionSteps": [
          "Tel de twee getallen op: 2,4 + 2,6 = 5,0",
          "Deel door 2: 5,0 ÷ 2 = 2,5",
          "Controleer: afstand links = 2,5 − 2,4 = 0,1, afstand rechts = 2,6 − 2,5 = 0,1 ✓",
          "Halverwege = 2,5"
        ],
        "distractorExplanations": {
          "0": "Goed! Halverwege 2,4 en 2,6 = (2,4 + 2,6) ÷ 2 = 2,5.",
          "1": "Je dacht waarschijnlijk dat 2,45 halverwege ligt. Maar 2,45 − 2,4 = 0,05 en 2,6 − 2,45 = 0,15 — dat is niet gelijk. Halverwege = 2,5. Onthoud: controleer of de afstand aan beide kanten gelijk is.",
          "2": "Je dacht waarschijnlijk dat 2,55 halverwege ligt. Maar 2,55 − 2,4 = 0,15 en 2,6 − 2,55 = 0,05 — dat is niet gelijk. Halverwege = 2,5. Onthoud: controleer of de afstand aan beide kanten gelijk is.",
          "3": "Je dacht waarschijnlijk dat je de tienden optelt: 4 + 6 = 10 → 2,10. Maar halverwege bereken je door het gemiddelde te nemen: (2,4 + 2,6) ÷ 2 = 2,5. Onthoud: halverwege = gemiddelde van de twee getallen."
        }
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-009",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "estimation_slider",
      "question": "Waar hoort 2,7 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 5,
        "correctValue": 2.7,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "komma_slider_tienden",
      "variantIndex": 9,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "2,7 ligt tussen 2 en 3. Het ligt iets voorbij het midden (2,5). Tip: deel het stuk tussen 2 en 3 in tien gelijke stukken; 2,7 is dan het zevende streepje vanaf 2.",
        "solutionSteps": [
          "Kijk naar de getallenlijn van 0 tot 5",
          "Zoek het stuk tussen 2 en 3",
          "Het midden is 2,5",
          "Plaats de schuif iets voorbij het midden"
        ]
      }
    },
    {
      "id": "GET-KOMMA-GETALLENLIJN-010",
      "familyId": "GET-KOMMA-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_getallenlijn",
      "questionType": "estimation_slider",
      "question": "Waar hoort 0,45 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 1,
        "correctValue": 0.45,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "komma_slider_honderdsten",
      "variantIndex": 10,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "0,45 ligt tussen 0 en 1. Het ligt net iets voor het midden (0,50). Tip: deel de lijn in tien stukken van 0,1 — 0,45 zit dan halverwege het vierde en vijfde stukje.",
        "solutionSteps": [
          "Kijk naar de getallenlijn van 0 tot 1",
          "Het midden is 0,50 (of 0,5)",
          "0,45 is iets minder dan 0,50",
          "Plaats de schuif net voor het midden"
        ]
      }
    }
  ]
}